module.exports = __webpack_public_path__ + "static/img/05.ec666aeb.jpg";